import {Enrolment} from './enrolment';

export class ConfirmationMessage {
  enrolment: Enrolment;
  paymentReference: string;
  message: string;
}
